import {create} from "zustand";

export type StoreState = {
    opened: boolean;

    actions: {
        openModal: () => void;
        closeModal: () => void;
        toggleModal: () => void;
    };
};

export const store = create<StoreState>((set) => ({
    opened: false,

    actions: {
        openModal: () => set({opened: true}),
        closeModal: () => set({opened: false}),
        toggleModal: () => set(state => ({opened: !state.opened})),
    },
}));
